"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Guid = require("uuid/v4");
class VIS {
    /**
     * Creates an instance of vis.
     * By default connection gets open
     */
    constructor(license) {
        /**
         * Value to let execute requests
         */
        this.hasAccess = false;
        try {
            if (!license)
                throw Error("VIS needs a license file");
            this.license = license;
            this.socket = new WebSocket("ws://localhost:8477");
        }
        catch {
            throw Error("Error while openning VIS Connection");
        }
    }
    /**
     * Connects vis, Manual connection to initialize the WS connection
     */
    connect() {
        if (this.socket.readyState === 1)
            throw Error("WS is already open");
        if (typeof this.socket !== "undefined")
            this.socket = new WebSocket("ws://localhost:8477");
    }
    /**
     * Dissconects vis, Manual discconection from WS
     */
    dissconect() {
        if (!this.socket.OPEN)
            throw Error("WS is not open yet");
        this.socket.close();
    }
    /**
     * Process vis request
     * @param type Event to be send to VIS
     * @param callback Function to be returned in the client executing the command
     * @param [eventName] Path of the VIS CAN data, can be optional depending on the case
     * @param [value] Value if is require by event and path can be any format value
     */
    process(type, callback, path, value) {
        try {
            let request;
            if (!this.socket.OPEN)
                throw Error("WS is not open yet");
            // if (!this.hasAccess) throw Error('App does not have access to VIS');
            switch (type) {
                case "getToken":
                    request = this.getTokenRequest();
                    break;
                case "get":
                    request = this.getRequest(path, type);
                    break;
                case "set":
                    request = this.setRequest(path, value);
                    break;
                case "getMetadata":
                    request = this.getRequest(path, type);
                    break;
                case "subscribe":
                    request = this.getSubscribeRequest(path);
                    break;
                case "unsubscribe":
                    request = this.getUnSubscribeRequest(path);
                    break;
                case "unsubscribeAll":
                    request = this.getUnSubscribeAllRequest();
                    break;
                default:
                    throw Error("Allow types getToken, get, set, getMetaData, subscribe, unsubscribe, unsubscribeAll");
            }
            this.socket.send(JSON.stringify(request));
            this.socket.addEventListener("message", (eventResponse) => {
                const response = JSON.parse(eventResponse.data);
                if ((response.action === type &&
                    response.requestId === request.requestId) ||
                    response.action === "subscription") {
                    callback(response);
                }
            });
        }
        catch (error) {
            throw Error(error);
        }
    }
    /**
     * Gets token request
     * @returns token request W3C Standard request for getToken operation
     */
    getTokenRequest() {
        return {
            action: "getToken",
            requestId: Guid.create().toString(),
            value: this.license
        };
    }
    /**
     * Gets request for W3C get event
     * @param pathName Path to the VIS data
     * @param type Could be get or getmetdata to specify WS event
     * @returns request W3C Standard request for get or getMetaData operation
     */
    getRequest(pathName, type) {
        return {
            action: type,
            path: pathName,
            requestId: Guid.create().toString()
        };
    }
    /**
     * Sets request for W3C set event
     * @param pathName Path to the VIS data
     * @param eventValue Value to be set on the VIS data
     * @returns request W3C Standard request for set operation
     */
    setRequest(pathName, eventValue) {
        return {
            action: "set",
            path: pathName,
            requestId: Guid.create().toString(),
            value: eventValue
        };
    }
    /**
     * Gets subscribe request for W3C subscribe event
     * @param pathName Path to the VIS data
     * @returns subscribe request W3C Standard request for subscribe operation
     */
    getSubscribeRequest(pathName) {
        return {
            action: "subscribe",
            filters: {},
            path: pathName,
            requestId: Guid.create().toString()
        };
    }
    /**
     * Gets unsubscribe request for W3C unsubscribe event
     * @param id Get when sbubscribint to an event
     * @returns un subscribe request W3C Standard request for unsubscribe operation
     */
    getUnSubscribeRequest(id) {
        return {
            action: "unsubscribe",
            requestId: Guid.create().toString(),
            subscriptionId: id
        };
    }
    /**
     * Gets unsubscribeall request for W3C unsubscribeall event
     * @returns un subscribe all request W3C Standard request for unsubscribe all operation
     */
    getUnSubscribeAllRequest() {
        return {
            action: "unsubscribeAll",
            requestId: Guid.create().toString()
        };
    }
}
exports.default = VIS;
//# sourceMappingURL=Vis.js.map